import React from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import {Container} from '../components/Container/Container'
import Footer from '../components/Footer/Footer'
import Navbar from '../components/Navbar/Navbar'
import { Masonry } from "../components/Masonry";
import client from '../apollo/apollo-client'
import { BLOG_PAGE_QUERY }from '../apollo/query/blog_page_query'
import { IMG_URL } from "../apollo/client-url";

export async function getServerSideProps (context) {
  const { data, error, loading } = await client.query({
    query: BLOG_PAGE_QUERY,
    fetchPolicy: 'no-cache',
    variables: {
      metaWhere: {
        pageSlug: context.resolvedUrl
      }
    },
  }).catch((error) => {
    return error
  })

  return { props: { pages: data.allBlogs || [], allTextPage: data.allTextPages, allMetaTag: data.allMetaTags } };
}

function BlogListPage (props) {
  const router = useRouter()

  if (router?.asPath?.includes('[')) {
    return null
  }

  const metaTag = props.allMetaTag?.[0]

  return (
    <div className="static">
      <Head>
        <title>Blog</title>
        {metaTag?.title && <meta name="title" content={metaTag?.title} />}
        {metaTag?.title &&  <meta property="og:title" content={metaTag?.title} />}
        {metaTag?.title && <meta property="twitter:title" content={metaTag?.title} />}

        {metaTag?.description && <meta name="description" content={metaTag?.description} />}
        {metaTag?.description &&  <meta property="og:description" content={metaTag?.description} />}
        {metaTag?.description && <meta property="twitter:description" content={metaTag?.description} />}

        {metaTag?.ogType && <meta property="og:type" content={metaTag?.ogType} />}

        {metaTag?.twitterCard && <meta property="twitter:card" content={metaTag?.twitterCard} />}

        {metaTag?.imagePreview?.publicUrl && <meta property="og:image" content={`${IMG_URL}${metaTag.imagePreview.publicUrl}`} />}

        <meta name="viewport" content="initial-scale=1.0, width=device-width"/>
      </Head>
      <Navbar allTextPage={props.allTextPage} allBlogs={props.pages} />
      <Container>

        <h1 className="blog_title">
          Learn more about loyalty
        </h1>

        <Masonry brakePoints={[350, 500, 750]}>
          {props?.pages?.map((item, i) => {
            return (
              <div key={i} className='blog_item' onClick={() => router.push({
                pathname: 'blog/' + item.slug
              })}>
                <img src={item?.image?.publicUrl} alt="" />
                <mark>{item?.pageType}</mark>
                <span>{item?.title}</span>
              </div>
            )}
          )}
        </Masonry>

      </Container>
      <Footer allTextPage={props.allTextPage} allBlogs={props.pages} />
    </div>
  )
}

export default BlogListPage
